
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as modeling_45sell_45pressure2a8uMLBcDqP83illESxlXjUCznjw3lRZD9_9m5R3CcwMeta } from "/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/adjusting/modeling-sell-pressure.vue?macro=true";
import { default as modeling_45supply_45and_45demandQhj26gAtVxk94p1GNdAnR0asLo0YNw5d8QSKdFt8PhMMeta } from "/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/adjusting/modeling-supply-and-demand.vue?macro=true";
import { default as optimizing_45circulating_45supply_cVmTxt3UdlW8lIWywOdmTvLxm8kYfLnyIo3wIu4YbIMeta } from "/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/adjusting/optimizing-circulating-supply.vue?macro=true";
import { default as simulating_45post_45tge_45popsmQssXU1mYvUWkZ_D6d7AB7CQ98GRSTMS_yr__GmQRdIMeta } from "/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/adjusting/simulating-post-tge-pops.vue?macro=true";
import { default as simulating_45price_45discoverypM1Gtw2qHJMzt05sBS6SlOq8s8pyjKTJFQ3_npJC3hcMeta } from "/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/adjusting/simulating-price-discovery.vue?macro=true";
import { default as demand_45driversUccFkjbtzkmeQvBv6totRjuqXio3n25rH1uDEXmWVkIMeta } from "/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/modeling/demand-drivers.vue?macro=true";
import { default as estimating_45demand_4N9w9vxVZfL_TOABuzOA7sGvkD6dbN5apjGueNKA0gMeta } from "/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/modeling/estimating-demand.vue?macro=true";
import { default as token_45distribution_45scheduleLm2JnLInfFYmMXI3nHMPc1yZqqlOdWaPCfH5WzqQvLIMeta } from "/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/modeling/token-distribution-schedule.vue?macro=true";
import { default as token_45emission_45scheduleN0RuKN39lWZlYcLhGrjj1H_CyOoVVw_botLU1BAJuY0Meta } from "/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/modeling/token-emission-schedule.vue?macro=true";
import { default as manage_45one_45pagerXOQnBWOFtb8ugVR_2aa7Qik1ZIALBl2SUyiJqpOCjzYMeta } from "/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/publish/manage-one-pager.vue?macro=true";
import { default as basic_45informationzEyWnLVoensd1i2Ojdankpi8FPDreA4wZTwncFCl9T8Meta } from "/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/token-profile/basic-information.vue?macro=true";
import { default as business_45modelgzyaTxRcv8dzZoo7DU6CAkOu9obXfmSDCkku8_Ep3yMMeta } from "/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/token-profile/business-model.vue?macro=true";
import { default as mission_45visionrDdapW3foi7lWirw_mtC01b2oeNVz1LAQvoT3l5qk_8Meta } from "/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/token-profile/mission-vision.vue?macro=true";
import { default as problem_45and_45solutionEzau1SbzwBbwRa8A0DQXRoS8kJunvDHFdBZdKLbDBnwMeta } from "/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/token-profile/problem-and-solution.vue?macro=true";
import { default as product_45market_45fit2rnN4Gfraf3yVTZcBBKyc4Tdff3RDu0XpvGIK_trhE0Meta } from "/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/token-profile/product-market-fit.vue?macro=true";
import { default as value_45capturemGKdChV_huVkT87QXHNvKNwQH3xkKHbCshoAjWER2NYMeta } from "/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/token-profile/value-capture.vue?macro=true";
import { default as value_45creationxI6d595JCzDdyaH8ga6GsmxDgE4pL2lV8SxJDReEJQkMeta } from "/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/token-profile/value-creation.vue?macro=true";
import { default as fdv_45maximum_45token_45supply7FMEhPuLTSdMXz6lC8bdqffXKp3ajGum8kGF00qdaBoMeta } from "/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/valuation-documenting/fdv-maximum-token-supply.vue?macro=true";
import { default as compare_45quotesecDR48qHy_E3fYuFu_b7pL1tt1cjyb6oDKbUXPcmTJcMeta } from "/app/apps/ui/layers/free-tools/engage-market-maker/pages/engage-a-market-maker/demo/compare-quotes.vue?macro=true";
import { default as how_45it_45worksglj_J1RJFLcjSgAMUBgLXcpvquDwclsGCO9ME4VNFmsMeta } from "/app/libs/nuxt-forgd-layer-core/layers/market-maker-leaderboards/pages/market-maker-leaderboard/documentation/how-it-works.vue?macro=true";
import { default as _91code_93RGQLtjMakqy0cQgljqCiCrmD2sVUD22uahZFHWI67UUMeta } from "/app/apps/ui/layers/onboarding/pages/v2/invitation/[code].vue?macro=true";
import { default as advisoryYoatqX2DyTdE7TzqmqBY42agquEKQTA301DZayDEWLMMeta } from "/app/apps/ui/layers/site/pages/about/advisory.vue?macro=true";
import { default as blockchain_45advisorswTAmbTo_NW2zdjuawVphL_XCIu1k3p5C3gZgCwC8FOUMeta } from "/app/apps/ui/layers/site/pages/about/blockchain-advisors.vue?macro=true";
import { default as blockchain_45projects3CG9GtCcdgatCsSrXLSzKyBBaziOMv3MfkwKMBKTa8kMeta } from "/app/apps/ui/layers/site/pages/about/blockchain-projects.vue?macro=true";
import { default as contactz1kfITPS4_SF5rjZOWrQeDsshDaEO4Ly2W70pi4eNRAMeta } from "/app/apps/ui/layers/site/pages/about/contact.vue?macro=true";
import { default as faqs2YWLqZvc72eN9ZQNS58viSyit_M1D2hOguDUeEb3gi4Meta } from "/app/apps/ui/layers/site/pages/about/faqs.vue?macro=true";
import { default as market_45makersAWlGtrwrUReeqdiGSpLHSIlSl2QVjiIgIbKRIAJd3y0Meta } from "/app/apps/ui/layers/site/pages/about/market-makers.vue?macro=true";
import { default as pricingfqvpvFokoQUh7gaiBE7bl34EM1boiLw5nH7NCkHanGkMeta } from "/app/apps/ui/layers/site/pages/about/pricing.vue?macro=true";
import { default as what_45is_45forgd1uOnZtzvGWMWTk6sswnmYt8AJVaJAcMNVVRbfrXVoEsMeta } from "/app/apps/ui/layers/site/pages/about/what-is-forgd.vue?macro=true";
import { default as overviewKLQnK3hBrIKc8PB48HqO6_mHNU_QycqzYl12y8qBhe8Meta } from "/app/libs/nuxt-forgd-layer-core/layers/academy/pages/academy/overview.vue?macro=true";
import { default as teammatesN3l10aUtAkIsH_BcHgRz_hjo4WGJd73_cQzt2MrjtHAMeta } from "/app/apps/ui/layers/advisor-portal/pages/advisor-portal/teammates.vue?macro=true";
import { default as indexjXEq0ObUSznGA_zHxb6CPDnMyvP_p_c_jQUWZjt_eRUMeta } from "/app/libs/nuxt-forgd-layer-core/layers/auth/pages/auth/callback/index.vue?macro=true";
import { default as indexmTzUlweqm1Ji92mV3TzblUWEiJTAYzaikeWqdQ2L9BwMeta } from "/app/libs/nuxt-forgd-layer-core/layers/auth/pages/auth/finalize/index.vue?macro=true";
import { default as compare_45quotesql84kmHgWDkJjTSf3SJ6GYvTKmcy_S4Piy3xFx0SdQIMeta } from "/app/apps/ui/layers/free-tools/engage-market-maker/pages/engage-a-market-maker/compare-quotes.vue?macro=true";
import { default as indexkpZ4gVuvSo6as7VmKlaYE7BeOt52Z4FzUEpbtzk_UOEMeta } from "/app/apps/ui/layers/free-tools/engage-market-maker/pages/engage-a-market-maker/demo/index.vue?macro=true";
import { default as received_45quotes6o49vDOsHQNiWe6wDH_0Fw0U2jTjsOTIYIsvJly0EiUMeta } from "/app/apps/ui/layers/free-tools/engage-market-maker/pages/engage-a-market-maker/received-quotes.vue?macro=true";
import { default as received_45requotesRy312vjPyXtaaMI4C4Gz3gmCg_2FCcrrR4QdE_b6uv0Meta } from "/app/apps/ui/layers/free-tools/engage-market-maker/pages/engage-a-market-maker/received-requotes.vue?macro=true";
import { default as request_45for_45quotationsB3JXPOkI7m1ZI5qTdkXV_zLNMuCcptrK3SLBcEIxs4sMeta } from "/app/apps/ui/layers/free-tools/engage-market-maker/pages/engage-a-market-maker/request-for-quotations.vue?macro=true";
import { default as exchange_45ratingsCpMSNNJb16oz8msu8MUSjV0h1hubP3ev9ogi_NIqjrQMeta } from "/app/apps/ui/layers/free-tools/list-on-exchanges/pages/list-on-exchanges/exchange-ratings.vue?macro=true";
import { default as listing_45feesjr2ycoPzusSYYwiXoM1sAk2paKDBQCxAxyyJ26OdhHMMeta } from "/app/apps/ui/layers/free-tools/list-on-exchanges/pages/list-on-exchanges/listing-fees.vue?macro=true";
import { default as claim2DgI6TfwhX8BN4qVQcvg7X6vDJMyKmtt0wByMKE4D3UMeta } from "/app/apps/ui/pages/market-maker-leaderboard/claim.vue?macro=true";
import { default as depthQz9Da316dEcSYZM00h5m4ibZ8W7Wd5X87Wsd3SPvQI4Meta } from "/app/libs/nuxt-forgd-layer-core/layers/market-maker-leaderboards/pages/market-maker-leaderboard/depth.vue?macro=true";
import { default as indexyPD8K8m2Fdvd4OCh7X5Vl2IpITQODLjKkh7muIUP2qUMeta } from "/app/libs/nuxt-forgd-layer-core/layers/market-maker-leaderboards/pages/market-maker-leaderboard/documentation/index.vue?macro=true";
import { default as kpixrmbJ_Sd_qdJUyh9UAq4SRA3xXkBnakbRtAE8xnMjPAMeta } from "/app/libs/nuxt-forgd-layer-core/layers/market-maker-leaderboards/pages/market-maker-leaderboard/kpi.vue?macro=true";
import { default as spreadgNVKKm_y5LTiBh3eqeYRzxOXFIh8ZdtYNo_Gigi6of8Meta } from "/app/libs/nuxt-forgd-layer-core/layers/market-maker-leaderboards/pages/market-maker-leaderboard/spread.vue?macro=true";
import { default as volumeJAhfK7HPsGhc6e_Norm3odUprNYnjlKKX1a_JonbWAYMeta } from "/app/libs/nuxt-forgd-layer-core/layers/market-maker-leaderboards/pages/market-maker-leaderboard/volume.vue?macro=true";
import { default as dashboard57GYH2hEj2JlV6WLKr4aZIpg_EDRlRNh6mb8YpAjzzsMeta } from "/app/apps/ui/layers/free-tools/monitor-market-makers/pages/market-maker-monitoring/dashboard.vue?macro=true";
import { default as exchange_45and_45listingeuRblnnXBqzIl6_MAWS_gpxDzdhmiZkSal_ENPJIktoMeta } from "/app/apps/ui/layers/public-research/pages/research/exchange-and-listing.vue?macro=true";
import { default as tokenomicsjk81qKtM8u5NkUUy_ZTCDL6PNF3RQTR1PU_3bIiTdr0Meta } from "/app/apps/ui/layers/public-research/pages/research/tokenomics.vue?macro=true";
import { default as teammateso6qoSf1WKKJU7AmyEimDrW55TsUOn2NJELi8qfe4ETcMeta } from "/app/apps/ui/layers/settings/pages/token-settings/teammates.vue?macro=true";
import { default as universal_45token_45ratingHq77AqgptwmoxPuxZmKWo3MogpfE25UmV_uKdxeHExwMeta } from "/app/apps/ui/layers/settings/pages/token-settings/universal-token-rating.vue?macro=true";
import { default as claimk_6KLUBAdB6vcEXNJhIT9QGEdzMsMKqFQhGArfstjIwMeta } from "/app/apps/ui/layers/public-research/pages/universal-token-rating/claim.vue?macro=true";
import { default as comparevk58cLP0P9zKlmEs1e0PPJ1kYzWt3LE2_weh5N4vNi8Meta } from "/app/apps/ui/layers/public-research/pages/universal-token-rating/compare.vue?macro=true";
import { default as authorizationSHWqTqhR7fkACnRbldV_WeqH89uHKIfGwj8N3N9_OuoMeta } from "/app/apps/ui/layers/onboarding/pages/v2/authorization.vue?macro=true";
import { default as teammaterdAOW7YyHxFToXQ3_loS8QQFyOlggunJo_HKDRNxNdoMeta } from "/app/apps/ui/layers/onboarding/pages/onboarding/[organizationId]/teammate.vue?macro=true";
import { default as sharePbbRTwhU_hPMkP9Lgu_RfGzCRx0Q1GYf1f7oysJIlKYMeta } from "/app/apps/ui/layers/public-research/pages/utr/[id]/share.vue?macro=true";
import { default as publicKlouK7fBICJ8pYxMoNUk2NYA8fKLlkmCbeUEGdR0UWsMeta } from "/app/apps/ui/layers/free-tools/design-tokenomics/pages/share/[ticker]/[projectId]/public.vue?macro=true";
import { default as _91slug_93qbSWofgz4rGFEaT08IMTT_2fvMgk3bGfAzdiYj8C3OwMeta } from "/app/apps/ui/layers/site/pages/blog/[slug].vue?macro=true";
import { default as _91exchangeId_93Yov3z_S9R8_7hiMpD4iX9zjTAdRAnV4d7V01VZLrUd8Meta } from "/app/apps/ui/layers/public-research/pages/universal-exchange-rating/[exchangeId].vue?macro=true";
import { default as _91id_93ALe9PTo8dQEz4sx2aE9UoCtc2nGYVV1r1X_JtumbK8sMeta } from "/app/apps/ui/layers/public-research/pages/universal-token-rating/[id].vue?macro=true";
import { default as _91_46_46_46slug_931usqlJmipvTshZ4bE4XIaW3mfslAMEhfyRNEkfWloEAMeta } from "/app/libs/nuxt-forgd-layer-core/layers/academy/pages/academy/[...slug].vue?macro=true";
import { default as indexOlgaaIzhCgNr6byGe_Kzq98uYCj5xjClgaZu_XczTR4Meta } from "/app/apps/ui/layers/advisor-portal/pages/advisor-portal/index.vue?macro=true";
import { default as indexZJ9a_YoiSPwF320_yVlht1ZNPhC_GZACBcpmE2bfPMgMeta } from "/app/apps/ui/layers/free-tools/trade-activity/pages/analyze-trade-activity/index.vue?macro=true";
import { default as askgM7ZPouZst8_BOM8IP9_aKR2829KMrpl1z09_hlWM_UMeta } from "/app/apps/ui/layers/ai-chat/pages/ask.vue?macro=true";
import { default as indexocrZEhS1hdcH_6JVpKdoGvx_krJKnajQru_yozkJWgwMeta } from "/app/apps/ui/layers/site/pages/blog/index.vue?macro=true";
import { default as indexMDxrahIngFnARYHOB8lFGnsNxmNeLWBObAykDfccCkcMeta } from "/app/libs/nuxt-forgd-layer-core/layers/auth/pages/confirm-email/index.vue?macro=true";
import { default as consultation4pqvGJ7znvVDM8cugcJoxcr772SEwTPFZCj6uXltCHkMeta } from "/app/apps/ui/layers/site/pages/consultation.vue?macro=true";
import { default as indextr3zpUO0UUWMgSgsJCuaS3lYVql8KzDzX1Pn_LLw2BMMeta } from "/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/index.vue?macro=true";
import { default as indexI_KVW5OAFV_Ne14orK8EpUPspl8_FRkRELLYI4QCbeAMeta } from "/app/libs/nuxt-forgd-layer-core/layers/auth/pages/email-redirect/index.vue?macro=true";
import { default as indexVj8OawVyaXbSZkQkfce29Dv60Kl5Mc2foCjl8a33D4IMeta } from "/app/apps/ui/layers/free-tools/engage-market-maker/pages/engage-a-market-maker/index.vue?macro=true";
import { default as indexA7iNbPQ1E0AOSs5JH6W9sV_USpASVWKFpkClryriMwIMeta } from "/app/libs/nuxt-forgd-layer-core/layers/auth/pages/forgot-password/index.vue?macro=true";
import { default as indexA_OMR81fehF1eqSCX9UWLgSmUs1mRA2GESPEwTrBXG8Meta } from "/app/apps/ui/layers/free-tools/list-on-exchanges/pages/list-on-exchanges/index.vue?macro=true";
import { default as indexTSYlIwBXwQQdBuazDO63jU4fQDOL9CUztVuNVibxW8wMeta } from "/app/libs/nuxt-forgd-layer-core/layers/auth/pages/login/index.vue?macro=true";
import { default as indexrs_Y6RVUaS6Aw4LAXajbMuKwf2_VNbRgybvUPehwvjgMeta } from "/app/libs/nuxt-forgd-layer-core/layers/auth/pages/magic-link/index.vue?macro=true";
import { default as index4GnxqYuGjJCi5LnjPqpHVTwemY8jXabtLxtRINeKeL4Meta } from "/app/libs/nuxt-forgd-layer-core/layers/market-maker-leaderboards/pages/market-maker-leaderboard/index.vue?macro=true";
import { default as indexPNFY0G6yj6JIqlCH2itWITnt1oJl3WX3PpvkpOMuoEcMeta } from "/app/apps/ui/layers/free-tools/monitor-market-makers/pages/market-maker-monitoring/index.vue?macro=true";
import { default as indexRDnM2lUXLwU0pEu2tI4WvJXN2h53Krpj9lnalHoXOU8Meta } from "/app/apps/ui/layers/onboarding/pages/onboarding/index.vue?macro=true";
import { default as indexW2cfYUBvhIraz8oMlgdumxmIdzq4l3d7_8FGyND_F9IMeta } from "/app/libs/nuxt-forgd-layer-core/layers/auth/pages/page-not-found/index.vue?macro=true";
import { default as privacy_45policyNgH00aDbvWOBbDArnMjP1Gfo78mjmqBJIMBe17AD6XQMeta } from "/app/apps/ui/layers/site/pages/privacy-policy.vue?macro=true";
import { default as indexCWg6QrS0V_9nbwaY0lDQiSucoy8566FY7Af80_Mm8nwMeta } from "/app/apps/ui/layers/onboarding/pages/register/index.vue?macro=true";
import { default as indextJsmddBhNYttOXoorpQh_44uMI__scwcGmyo2eQWHfMMeta } from "/app/libs/nuxt-forgd-layer-core/layers/auth/pages/reset-password/index.vue?macro=true";
import { default as indexFE12rnOBvaZNZE5Vege461QclnSMm2mRlZtsOJgUZy8Meta } from "/app/apps/ui/layers/settings/pages/settings/index.vue?macro=true";
import { default as support6GkTiYJUw6PtDxtUS6ceDtsauy0mMtPbdi_6iK2xasoMeta } from "/app/apps/ui/pages/support.vue?macro=true";
import { default as terms_45conditionsh68WvpKRsMObbLIC33NSZBW5Ip19M7haw5NBG_tegK0Meta } from "/app/apps/ui/layers/site/pages/terms-conditions.vue?macro=true";
import { default as indexQLFtDtOMXqoEcm_xTKGWBrFIne7HlxKFrrxE4bHq8lQMeta } from "/app/libs/nuxt-forgd-layer-core/layers/auth/pages/token-expired/index.vue?macro=true";
import { default as index3rNqNEZofE7EKijRfcycbHdTzMupCn7Ev_EZ6_Zp37sMeta } from "/app/apps/ui/layers/settings/pages/token-settings/index.vue?macro=true";
import { default as indexefloXmcYGy_fevfCUkYH2VQAMO6fCMJOpVqTp15PXxkMeta } from "/app/apps/ui/layers/public-research/pages/universal-exchange-rating/index.vue?macro=true";
import { default as indexvdbtSQPokg9q0NR5nVYtCkrHR1nBMK5kOApyehMfuhEMeta } from "/app/apps/ui/layers/public-research/pages/universal-token-rating/index.vue?macro=true";
import { default as indexZ_OKy2VewP_zbdzzx_njNwZpPCu0XKTRRUkoQ9TuWiYMeta } from "/app/libs/nuxt-forgd-layer-core/layers/auth/pages/verify-email/index.vue?macro=true";
import { default as indexxkl7THrorjELX0PmwfNI1rncgoIz67vMSTWZxNvAZMQMeta } from "/app/apps/ui/pages/index.vue?macro=true";
import { default as component_45stubNJqXUND8TpxJhMGJI6VYCw9xq9hYQu6ZlIQ2YjHb8PY } from "/app/node_modules/.pnpm/nuxt@4.5.2_b39e155b9d5ab875bcce11a20b66e7bf/node_modules/nuxt/dist/pages/runtime/component-stub.js";
import { default as component_45stubNJqXUND8TpxJhMGJI6VYCw9xq9hYQu6ZlIQ2YjHb8PYMeta } from "/app/node_modules/.pnpm/nuxt@4.5.2_b39e155b9d5ab875bcce11a20b66e7bf/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
export default [
  {
    name: "project-projectId-design-tokenomics-adjusting-modeling-sell-pressure",
    path: "/project/:projectId()/design-tokenomics/adjusting/modeling-sell-pressure",
    meta: { ...(modeling_45sell_45pressure2a8uMLBcDqP83illESxlXjUCznjw3lRZD9_9m5R3CcwMeta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/adjusting/modeling-sell-pressure.vue")
  },
  {
    name: "project-projectId-design-tokenomics-adjusting-modeling-supply-and-demand",
    path: "/project/:projectId()/design-tokenomics/adjusting/modeling-supply-and-demand",
    meta: { ...(modeling_45supply_45and_45demandQhj26gAtVxk94p1GNdAnR0asLo0YNw5d8QSKdFt8PhMMeta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/adjusting/modeling-supply-and-demand.vue")
  },
  {
    name: "project-projectId-design-tokenomics-adjusting-optimizing-circulating-supply",
    path: "/project/:projectId()/design-tokenomics/adjusting/optimizing-circulating-supply",
    meta: { ...(optimizing_45circulating_45supply_cVmTxt3UdlW8lIWywOdmTvLxm8kYfLnyIo3wIu4YbIMeta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/adjusting/optimizing-circulating-supply.vue")
  },
  {
    name: "project-projectId-design-tokenomics-adjusting-simulating-post-tge-pops",
    path: "/project/:projectId()/design-tokenomics/adjusting/simulating-post-tge-pops",
    meta: { ...(simulating_45post_45tge_45popsmQssXU1mYvUWkZ_D6d7AB7CQ98GRSTMS_yr__GmQRdIMeta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/adjusting/simulating-post-tge-pops.vue")
  },
  {
    name: "project-projectId-design-tokenomics-adjusting-simulating-price-discovery",
    path: "/project/:projectId()/design-tokenomics/adjusting/simulating-price-discovery",
    meta: { ...(simulating_45price_45discoverypM1Gtw2qHJMzt05sBS6SlOq8s8pyjKTJFQ3_npJC3hcMeta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/adjusting/simulating-price-discovery.vue")
  },
  {
    name: "project-projectId-design-tokenomics-modeling-demand-drivers",
    path: "/project/:projectId()/design-tokenomics/modeling/demand-drivers",
    meta: { ...(demand_45driversUccFkjbtzkmeQvBv6totRjuqXio3n25rH1uDEXmWVkIMeta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/modeling/demand-drivers.vue")
  },
  {
    name: "project-projectId-design-tokenomics-modeling-estimating-demand",
    path: "/project/:projectId()/design-tokenomics/modeling/estimating-demand",
    meta: { ...(estimating_45demand_4N9w9vxVZfL_TOABuzOA7sGvkD6dbN5apjGueNKA0gMeta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/modeling/estimating-demand.vue")
  },
  {
    name: "project-projectId-design-tokenomics-modeling-token-distribution-schedule",
    path: "/project/:projectId()/design-tokenomics/modeling/token-distribution-schedule",
    meta: { ...(token_45distribution_45scheduleLm2JnLInfFYmMXI3nHMPc1yZqqlOdWaPCfH5WzqQvLIMeta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/modeling/token-distribution-schedule.vue")
  },
  {
    name: "project-projectId-design-tokenomics-modeling-token-emission-schedule",
    path: "/project/:projectId()/design-tokenomics/modeling/token-emission-schedule",
    meta: { ...(token_45emission_45scheduleN0RuKN39lWZlYcLhGrjj1H_CyOoVVw_botLU1BAJuY0Meta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/modeling/token-emission-schedule.vue")
  },
  {
    name: "project-projectId-design-tokenomics-publish-manage-one-pager",
    path: "/project/:projectId()/design-tokenomics/publish/manage-one-pager",
    meta: { ...(manage_45one_45pagerXOQnBWOFtb8ugVR_2aa7Qik1ZIALBl2SUyiJqpOCjzYMeta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/publish/manage-one-pager.vue")
  },
  {
    name: "project-projectId-design-tokenomics-token-profile-basic-information",
    path: "/project/:projectId()/design-tokenomics/token-profile/basic-information",
    meta: { ...(basic_45informationzEyWnLVoensd1i2Ojdankpi8FPDreA4wZTwncFCl9T8Meta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/token-profile/basic-information.vue")
  },
  {
    name: "project-projectId-design-tokenomics-token-profile-business-model",
    path: "/project/:projectId()/design-tokenomics/token-profile/business-model",
    meta: { ...(business_45modelgzyaTxRcv8dzZoo7DU6CAkOu9obXfmSDCkku8_Ep3yMMeta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/token-profile/business-model.vue")
  },
  {
    name: "project-projectId-design-tokenomics-token-profile-mission-vision",
    path: "/project/:projectId()/design-tokenomics/token-profile/mission-vision",
    meta: { ...(mission_45visionrDdapW3foi7lWirw_mtC01b2oeNVz1LAQvoT3l5qk_8Meta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/token-profile/mission-vision.vue")
  },
  {
    name: "project-projectId-design-tokenomics-token-profile-problem-and-solution",
    path: "/project/:projectId()/design-tokenomics/token-profile/problem-and-solution",
    meta: { ...(problem_45and_45solutionEzau1SbzwBbwRa8A0DQXRoS8kJunvDHFdBZdKLbDBnwMeta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/token-profile/problem-and-solution.vue")
  },
  {
    name: "project-projectId-design-tokenomics-token-profile-product-market-fit",
    path: "/project/:projectId()/design-tokenomics/token-profile/product-market-fit",
    meta: { ...(product_45market_45fit2rnN4Gfraf3yVTZcBBKyc4Tdff3RDu0XpvGIK_trhE0Meta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/token-profile/product-market-fit.vue")
  },
  {
    name: "project-projectId-design-tokenomics-token-profile-value-capture",
    path: "/project/:projectId()/design-tokenomics/token-profile/value-capture",
    meta: { ...(value_45capturemGKdChV_huVkT87QXHNvKNwQH3xkKHbCshoAjWER2NYMeta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/token-profile/value-capture.vue")
  },
  {
    name: "project-projectId-design-tokenomics-token-profile-value-creation",
    path: "/project/:projectId()/design-tokenomics/token-profile/value-creation",
    meta: { ...(value_45creationxI6d595JCzDdyaH8ga6GsmxDgE4pL2lV8SxJDReEJQkMeta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/token-profile/value-creation.vue")
  },
  {
    name: "project-projectId-design-tokenomics-valuation-documenting-fdv-maximum-token-supply",
    path: "/project/:projectId()/design-tokenomics/valuation-documenting/fdv-maximum-token-supply",
    meta: { ...(fdv_45maximum_45token_45supply7FMEhPuLTSdMXz6lC8bdqffXKp3ajGum8kGF00qdaBoMeta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/valuation-documenting/fdv-maximum-token-supply.vue")
  },
  {
    name: "project-projectId-engage-a-market-maker-demo-compare-quotes",
    path: "/project/:projectId()/engage-a-market-maker/demo/compare-quotes",
    meta: { ...(compare_45quotesecDR48qHy_E3fYuFu_b7pL1tt1cjyb6oDKbUXPcmTJcMeta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/engage-market-maker/pages/engage-a-market-maker/demo/compare-quotes.vue")
  },
  {
    name: "market-maker-leaderboard-documentation-how-it-works",
    path: "/market-maker-leaderboard/documentation/how-it-works",
    meta: how_45it_45worksglj_J1RJFLcjSgAMUBgLXcpvquDwclsGCO9ME4VNFmsMeta || {},
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/market-maker-leaderboards/pages/market-maker-leaderboard/documentation/how-it-works.vue")
  },
  {
    name: "v2-invitation-code",
    path: "/v2/invitation/:code()",
    meta: { ...(_91code_93RGQLtjMakqy0cQgljqCiCrmD2sVUD22uahZFHWI67UUMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/app/apps/ui/layers/onboarding/pages/v2/invitation/[code].vue")
  },
  {
    name: "about-advisory",
    path: "/about/advisory",
    meta: { ...(advisoryYoatqX2DyTdE7TzqmqBY42agquEKQTA301DZayDEWLMMeta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/site/pages/about/advisory.vue")
  },
  {
    name: "about-blockchain-advisors",
    path: "/about/blockchain-advisors",
    meta: { ...(blockchain_45advisorswTAmbTo_NW2zdjuawVphL_XCIu1k3p5C3gZgCwC8FOUMeta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/site/pages/about/blockchain-advisors.vue")
  },
  {
    name: "about-blockchain-projects",
    path: "/about/blockchain-projects",
    meta: { ...(blockchain_45projects3CG9GtCcdgatCsSrXLSzKyBBaziOMv3MfkwKMBKTa8kMeta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/site/pages/about/blockchain-projects.vue")
  },
  {
    name: "about-contact",
    path: "/about/contact",
    meta: { ...(contactz1kfITPS4_SF5rjZOWrQeDsshDaEO4Ly2W70pi4eNRAMeta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/site/pages/about/contact.vue")
  },
  {
    name: "about-faqs",
    path: "/about/faqs",
    meta: { ...(faqs2YWLqZvc72eN9ZQNS58viSyit_M1D2hOguDUeEb3gi4Meta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/site/pages/about/faqs.vue")
  },
  {
    name: "about-market-makers",
    path: "/about/market-makers",
    meta: { ...(market_45makersAWlGtrwrUReeqdiGSpLHSIlSl2QVjiIgIbKRIAJd3y0Meta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/site/pages/about/market-makers.vue")
  },
  {
    name: "about-pricing",
    path: "/about/pricing",
    meta: { ...(pricingfqvpvFokoQUh7gaiBE7bl34EM1boiLw5nH7NCkHanGkMeta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/site/pages/about/pricing.vue")
  },
  {
    name: "about-what-is-forgd",
    path: "/about/what-is-forgd",
    meta: { ...(what_45is_45forgd1uOnZtzvGWMWTk6sswnmYt8AJVaJAcMNVVRbfrXVoEsMeta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/site/pages/about/what-is-forgd.vue")
  },
  {
    name: "academy-overview",
    path: "/academy/overview",
    meta: overviewKLQnK3hBrIKc8PB48HqO6_mHNU_QycqzYl12y8qBhe8Meta || {},
    alias: ["/academy"],
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/academy/pages/academy/overview.vue")
  },
  {
    name: "advisor-portal-teammates",
    path: "/advisor-portal/teammates",
    meta: { ...(teammatesN3l10aUtAkIsH_BcHgRz_hjo4WGJd73_cQzt2MrjtHAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/apps/ui/layers/advisor-portal/pages/advisor-portal/teammates.vue")
  },
  {
    name: "auth-callback",
    path: "/auth/callback",
    meta: indexjXEq0ObUSznGA_zHxb6CPDnMyvP_p_c_jQUWZjt_eRUMeta || {},
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/auth/pages/auth/callback/index.vue")
  },
  {
    name: "auth-finalize",
    path: "/auth/finalize",
    meta: indexmTzUlweqm1Ji92mV3TzblUWEiJTAYzaikeWqdQ2L9BwMeta || {},
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/auth/pages/auth/finalize/index.vue")
  },
  {
    name: "project-projectId-engage-a-market-maker-compare-quotes",
    path: "/project/:projectId()/engage-a-market-maker/compare-quotes",
    meta: { ...(compare_45quotesql84kmHgWDkJjTSf3SJ6GYvTKmcy_S4Piy3xFx0SdQIMeta || {}), ...{"middleware":["auth","rfq-compare-guard"]} },
    component: () => import("/app/apps/ui/layers/free-tools/engage-market-maker/pages/engage-a-market-maker/compare-quotes.vue")
  },
  {
    name: "project-projectId-engage-a-market-maker-demo",
    path: "/project/:projectId()/engage-a-market-maker/demo",
    meta: { ...(indexkpZ4gVuvSo6as7VmKlaYE7BeOt52Z4FzUEpbtzk_UOEMeta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/engage-market-maker/pages/engage-a-market-maker/demo/index.vue")
  },
  {
    name: "project-projectId-engage-a-market-maker-received-quotes",
    path: "/project/:projectId()/engage-a-market-maker/received-quotes",
    meta: { ...(received_45quotes6o49vDOsHQNiWe6wDH_0Fw0U2jTjsOTIYIsvJly0EiUMeta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/engage-market-maker/pages/engage-a-market-maker/received-quotes.vue")
  },
  {
    name: "project-projectId-engage-a-market-maker-received-requotes",
    path: "/project/:projectId()/engage-a-market-maker/received-requotes",
    meta: { ...(received_45requotesRy312vjPyXtaaMI4C4Gz3gmCg_2FCcrrR4QdE_b6uv0Meta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/engage-market-maker/pages/engage-a-market-maker/received-requotes.vue")
  },
  {
    name: "project-projectId-engage-a-market-maker-request-for-quotations",
    path: "/project/:projectId()/engage-a-market-maker/request-for-quotations",
    meta: { ...(request_45for_45quotationsB3JXPOkI7m1ZI5qTdkXV_zLNMuCcptrK3SLBcEIxs4sMeta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/engage-market-maker/pages/engage-a-market-maker/request-for-quotations.vue")
  },
  {
    name: "project-projectId-list-on-exchanges-exchange-ratings",
    path: "/project/:projectId()/list-on-exchanges/exchange-ratings",
    meta: { ...(exchange_45ratingsCpMSNNJb16oz8msu8MUSjV0h1hubP3ev9ogi_NIqjrQMeta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/list-on-exchanges/pages/list-on-exchanges/exchange-ratings.vue")
  },
  {
    name: "project-projectId-list-on-exchanges-listing-fees",
    path: "/project/:projectId()/list-on-exchanges/listing-fees",
    meta: { ...(listing_45feesjr2ycoPzusSYYwiXoM1sAk2paKDBQCxAxyyJ26OdhHMMeta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/list-on-exchanges/pages/list-on-exchanges/listing-fees.vue")
  },
  {
    name: "market-maker-leaderboard-claim",
    path: "/market-maker-leaderboard/claim",
    meta: claim2DgI6TfwhX8BN4qVQcvg7X6vDJMyKmtt0wByMKE4D3UMeta || {},
    component: () => import("/app/apps/ui/pages/market-maker-leaderboard/claim.vue")
  },
  {
    name: "market-maker-leaderboard-depth",
    path: "/market-maker-leaderboard/depth",
    meta: depthQz9Da316dEcSYZM00h5m4ibZ8W7Wd5X87Wsd3SPvQI4Meta || {},
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/market-maker-leaderboards/pages/market-maker-leaderboard/depth.vue")
  },
  {
    name: "market-maker-leaderboard-documentation",
    path: "/market-maker-leaderboard/documentation",
    meta: indexyPD8K8m2Fdvd4OCh7X5Vl2IpITQODLjKkh7muIUP2qUMeta || {},
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/market-maker-leaderboards/pages/market-maker-leaderboard/documentation/index.vue")
  },
  {
    name: "market-maker-leaderboard-kpi",
    path: "/market-maker-leaderboard/kpi",
    meta: kpixrmbJ_Sd_qdJUyh9UAq4SRA3xXkBnakbRtAE8xnMjPAMeta || {},
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/market-maker-leaderboards/pages/market-maker-leaderboard/kpi.vue")
  },
  {
    name: "market-maker-leaderboard-spread",
    path: "/market-maker-leaderboard/spread",
    meta: spreadgNVKKm_y5LTiBh3eqeYRzxOXFIh8ZdtYNo_Gigi6of8Meta || {},
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/market-maker-leaderboards/pages/market-maker-leaderboard/spread.vue")
  },
  {
    name: "market-maker-leaderboard-volume",
    path: "/market-maker-leaderboard/volume",
    meta: volumeJAhfK7HPsGhc6e_Norm3odUprNYnjlKKX1a_JonbWAYMeta || {},
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/market-maker-leaderboards/pages/market-maker-leaderboard/volume.vue")
  },
  {
    name: "project-projectId-market-maker-monitoring-dashboard",
    path: "/project/:projectId()/market-maker-monitoring/dashboard",
    meta: { ...(dashboard57GYH2hEj2JlV6WLKr4aZIpg_EDRlRNh6mb8YpAjzzsMeta || {}), ...{"middleware":["mmm-v2-pre-activation","check-market-maker-dashboard"],"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/monitor-market-makers/pages/market-maker-monitoring/dashboard.vue")
  },
  {
    name: "research-exchange-and-listing",
    path: "/research/exchange-and-listing",
    meta: exchange_45and_45listingeuRblnnXBqzIl6_MAWS_gpxDzdhmiZkSal_ENPJIktoMeta || {},
    component: () => import("/app/apps/ui/layers/public-research/pages/research/exchange-and-listing.vue")
  },
  {
    name: "research-tokenomics",
    path: "/research/tokenomics",
    meta: tokenomicsjk81qKtM8u5NkUUy_ZTCDL6PNF3RQTR1PU_3bIiTdr0Meta || {},
    component: () => import("/app/apps/ui/layers/public-research/pages/research/tokenomics.vue")
  },
  {
    name: "project-projectId-token-settings-teammates",
    path: "/project/:projectId()/token-settings/teammates",
    meta: { ...(teammateso6qoSf1WKKJU7AmyEimDrW55TsUOn2NJELi8qfe4ETcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/apps/ui/layers/settings/pages/token-settings/teammates.vue")
  },
  {
    name: "project-projectId-token-settings-universal-token-rating",
    path: "/project/:projectId()/token-settings/universal-token-rating",
    meta: { ...(universal_45token_45ratingHq77AqgptwmoxPuxZmKWo3MogpfE25UmV_uKdxeHExwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/apps/ui/layers/settings/pages/token-settings/universal-token-rating.vue")
  },
  {
    name: "universal-token-rating-claim",
    path: "/universal-token-rating/claim",
    meta: { ...(claimk_6KLUBAdB6vcEXNJhIT9QGEdzMsMKqFQhGArfstjIwMeta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/public-research/pages/universal-token-rating/claim.vue")
  },
  {
    name: "universal-token-rating-compare",
    path: "/universal-token-rating/compare",
    meta: { ...(comparevk58cLP0P9zKlmEs1e0PPJ1kYzWt3LE2_weh5N4vNi8Meta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/public-research/pages/universal-token-rating/compare.vue")
  },
  {
    name: "v2-authorization",
    path: "/v2/authorization",
    meta: authorizationSHWqTqhR7fkACnRbldV_WeqH89uHKIfGwj8N3N9_OuoMeta || {},
    component: () => import("/app/apps/ui/layers/onboarding/pages/v2/authorization.vue")
  },
  {
    name: "onboarding-organizationId-teammate",
    path: "/onboarding/:organizationId()/teammate",
    meta: { ...(teammaterdAOW7YyHxFToXQ3_loS8QQFyOlggunJo_HKDRNxNdoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/apps/ui/layers/onboarding/pages/onboarding/[organizationId]/teammate.vue")
  },
  {
    name: "project-projectId-utr-id-share",
    path: "/project/:projectId()/utr/:id()/share",
    meta: { ...(sharePbbRTwhU_hPMkP9Lgu_RfGzCRx0Q1GYf1f7oysJIlKYMeta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/public-research/pages/utr/[id]/share.vue")
  },
  {
    name: "share-ticker-projectId-public",
    path: "/share/:ticker()/:projectId()/public",
    meta: publicKlouK7fBICJ8pYxMoNUk2NYA8fKLlkmCbeUEGdR0UWsMeta || {},
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/share/[ticker]/[projectId]/public.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    meta: { ...(_91slug_93qbSWofgz4rGFEaT08IMTT_2fvMgk3bGfAzdiYj8C3OwMeta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/site/pages/blog/[slug].vue")
  },
  {
    name: "project-projectId-universal-exchange-rating-exchangeId",
    path: "/project/:projectId()/universal-exchange-rating/:exchangeId()",
    meta: { ...(_91exchangeId_93Yov3z_S9R8_7hiMpD4iX9zjTAdRAnV4d7V01VZLrUd8Meta || {}), ...{"middleware":["uer-enabled"],"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/public-research/pages/universal-exchange-rating/[exchangeId].vue")
  },
  {
    name: "universal-token-rating-id",
    path: "/universal-token-rating/:id()",
    meta: { ...(_91id_93ALe9PTo8dQEz4sx2aE9UoCtc2nGYVV1r1X_JtumbK8sMeta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/public-research/pages/universal-token-rating/[id].vue")
  },
  {
    name: "academy-slug",
    path: "/academy/:slug(.*)*",
    meta: _91_46_46_46slug_931usqlJmipvTshZ4bE4XIaW3mfslAMEhfyRNEkfWloEAMeta || {},
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/academy/pages/academy/[...slug].vue")
  },
  {
    name: "advisor-portal",
    path: "/advisor-portal",
    meta: { ...(indexOlgaaIzhCgNr6byGe_Kzq98uYCj5xjClgaZu_XczTR4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/apps/ui/layers/advisor-portal/pages/advisor-portal/index.vue")
  },
  {
    name: "project-projectId-analyze-trade-activity",
    path: "/project/:projectId()/analyze-trade-activity",
    meta: { ...(indexZJ9a_YoiSPwF320_yVlht1ZNPhC_GZACBcpmE2bfPMgMeta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/trade-activity/pages/analyze-trade-activity/index.vue")
  },
  {
    name: "project-projectId-ask",
    path: "/project/:projectId()/ask",
    meta: { ...(askgM7ZPouZst8_BOM8IP9_aKR2829KMrpl1z09_hlWM_UMeta || {}), ...{"middleware":["ai-chat-enabled"],"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/ai-chat/pages/ask.vue")
  },
  {
    name: "blog",
    path: "/blog",
    meta: { ...(indexocrZEhS1hdcH_6JVpKdoGvx_krJKnajQru_yozkJWgwMeta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/site/pages/blog/index.vue")
  },
  {
    name: "confirm-email",
    path: "/confirm-email",
    meta: indexMDxrahIngFnARYHOB8lFGnsNxmNeLWBObAykDfccCkcMeta || {},
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/auth/pages/confirm-email/index.vue")
  },
  {
    name: "consultation",
    path: "/consultation",
    meta: { ...(consultation4pqvGJ7znvVDM8cugcJoxcr772SEwTPFZCj6uXltCHkMeta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/site/pages/consultation.vue")
  },
  {
    name: "project-projectId-design-tokenomics",
    path: "/project/:projectId()/design-tokenomics",
    meta: { ...(indextr3zpUO0UUWMgSgsJCuaS3lYVql8KzDzX1Pn_LLw2BMMeta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/index.vue")
  },
  {
    name: "email-redirect",
    path: "/email-redirect",
    meta: indexI_KVW5OAFV_Ne14orK8EpUPspl8_FRkRELLYI4QCbeAMeta || {},
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/auth/pages/email-redirect/index.vue")
  },
  {
    name: "project-projectId-engage-a-market-maker",
    path: "/project/:projectId()/engage-a-market-maker",
    meta: { ...(indexVj8OawVyaXbSZkQkfce29Dv60Kl5Mc2foCjl8a33D4IMeta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/engage-market-maker/pages/engage-a-market-maker/index.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: { ...(indexA7iNbPQ1E0AOSs5JH6W9sV_USpASVWKFpkClryriMwIMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/auth/pages/forgot-password/index.vue")
  },
  {
    name: "project-projectId-list-on-exchanges",
    path: "/project/:projectId()/list-on-exchanges",
    meta: { ...(indexA_OMR81fehF1eqSCX9UWLgSmUs1mRA2GESPEwTrBXG8Meta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/list-on-exchanges/pages/list-on-exchanges/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: indexTSYlIwBXwQQdBuazDO63jU4fQDOL9CUztVuNVibxW8wMeta || {},
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/auth/pages/login/index.vue")
  },
  {
    name: "magic-link",
    path: "/magic-link",
    meta: indexrs_Y6RVUaS6Aw4LAXajbMuKwf2_VNbRgybvUPehwvjgMeta || {},
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/auth/pages/magic-link/index.vue")
  },
  {
    name: "market-maker-leaderboard",
    path: "/market-maker-leaderboard",
    meta: index4GnxqYuGjJCi5LnjPqpHVTwemY8jXabtLxtRINeKeL4Meta || {},
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/market-maker-leaderboards/pages/market-maker-leaderboard/index.vue")
  },
  {
    name: "project-projectId-market-maker-monitoring",
    path: "/project/:projectId()/market-maker-monitoring",
    meta: { ...(indexPNFY0G6yj6JIqlCH2itWITnt1oJl3WX3PpvkpOMuoEcMeta || {}), ...{"middleware":["mmm-v2-pre-activation","check-market-maker-dashboard"],"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/monitor-market-makers/pages/market-maker-monitoring/index.vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    meta: { ...(indexRDnM2lUXLwU0pEu2tI4WvJXN2h53Krpj9lnalHoXOU8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/apps/ui/layers/onboarding/pages/onboarding/index.vue")
  },
  {
    name: "page-not-found",
    path: "/page-not-found",
    meta: indexW2cfYUBvhIraz8oMlgdumxmIdzq4l3d7_8FGyND_F9IMeta || {},
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/auth/pages/page-not-found/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: { ...(privacy_45policyNgH00aDbvWOBbDArnMjP1Gfo78mjmqBJIMBe17AD6XQMeta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/site/pages/privacy-policy.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: { ...(indexCWg6QrS0V_9nbwaY0lDQiSucoy8566FY7Af80_Mm8nwMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/app/apps/ui/layers/onboarding/pages/register/index.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: { ...(indextJsmddBhNYttOXoorpQh_44uMI__scwcGmyo2eQWHfMMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/auth/pages/reset-password/index.vue")
  },
  {
    name: "project-projectId-settings",
    path: "/project/:projectId()/settings",
    meta: { ...(indexFE12rnOBvaZNZE5Vege461QclnSMm2mRlZtsOJgUZy8Meta || {}), ...{"middleware":"auth"} },
    alias: ["/settings"],
    component: () => import("/app/apps/ui/layers/settings/pages/settings/index.vue")
  },
  {
    name: "support",
    path: "/support",
    meta: support6GkTiYJUw6PtDxtUS6ceDtsauy0mMtPbdi_6iK2xasoMeta || {},
    component: () => import("/app/apps/ui/pages/support.vue")
  },
  {
    name: "terms-conditions",
    path: "/terms-conditions",
    meta: { ...(terms_45conditionsh68WvpKRsMObbLIC33NSZBW5Ip19M7haw5NBG_tegK0Meta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/site/pages/terms-conditions.vue")
  },
  {
    name: "token-expired",
    path: "/token-expired",
    meta: indexQLFtDtOMXqoEcm_xTKGWBrFIne7HlxKFrrxE4bHq8lQMeta || {},
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/auth/pages/token-expired/index.vue")
  },
  {
    name: "project-projectId-token-settings",
    path: "/project/:projectId()/token-settings",
    meta: { ...(index3rNqNEZofE7EKijRfcycbHdTzMupCn7Ev_EZ6_Zp37sMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/apps/ui/layers/settings/pages/token-settings/index.vue")
  },
  {
    name: "project-projectId-token-unlocks",
    path: "/project/:projectId()/token-unlocks",
    meta: {"allowPreLogin":true},
    component: () => import("/app/apps/ui/layers/free-tools/token-unlocks/pages/token-unlocks/index.vue")
  },
  {
    name: "project-projectId-universal-exchange-rating",
    path: "/project/:projectId()/universal-exchange-rating",
    meta: { ...(indexefloXmcYGy_fevfCUkYH2VQAMO6fCMJOpVqTp15PXxkMeta || {}), ...{"middleware":["uer-enabled"],"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/public-research/pages/universal-exchange-rating/index.vue")
  },
  {
    name: "universal-token-rating",
    path: "/universal-token-rating",
    meta: { ...(indexvdbtSQPokg9q0NR5nVYtCkrHR1nBMK5kOApyehMfuhEMeta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/public-research/pages/universal-token-rating/index.vue")
  },
  {
    name: "verify-email",
    path: "/verify-email",
    meta: { ...(indexZ_OKy2VewP_zbdzzx_njNwZpPCu0XKTRRUkoQ9TuWiYMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/app/libs/nuxt-forgd-layer-core/layers/auth/pages/verify-email/index.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexxkl7THrorjELX0PmwfNI1rncgoIz67vMSTWZxNvAZMQMeta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/pages/index.vue")
  },
  {
    name: component_45stubNJqXUND8TpxJhMGJI6VYCw9xq9hYQu6ZlIQ2YjHb8PYMeta?.name,
    path: "/research",
    component: component_45stubNJqXUND8TpxJhMGJI6VYCw9xq9hYQu6ZlIQ2YjHb8PY
  },
  {
    name: component_45stubNJqXUND8TpxJhMGJI6VYCw9xq9hYQu6ZlIQ2YjHb8PYMeta?.name,
    path: "/research/overview",
    component: component_45stubNJqXUND8TpxJhMGJI6VYCw9xq9hYQu6ZlIQ2YjHb8PY
  },
  {
    name: "project-projectId-undefined",
    path: "/project/:projectId()/post",
    component: component_45stubNJqXUND8TpxJhMGJI6VYCw9xq9hYQu6ZlIQ2YjHb8PY
  },
  {
    name: "project-projectId-undefined",
    path: "/project/:projectId()/post/:pathMatch(.*)",
    component: component_45stubNJqXUND8TpxJhMGJI6VYCw9xq9hYQu6ZlIQ2YjHb8PY
  },
  {
    name: component_45stubNJqXUND8TpxJhMGJI6VYCw9xq9hYQu6ZlIQ2YjHb8PYMeta?.name,
    path: "/about",
    component: component_45stubNJqXUND8TpxJhMGJI6VYCw9xq9hYQu6ZlIQ2YjHb8PY
  },
  {
    name: "project-projectId-undefined",
    path: "/project/:projectId()/pricing",
    component: component_45stubNJqXUND8TpxJhMGJI6VYCw9xq9hYQu6ZlIQ2YjHb8PY
  },
  {
    name: "project-projectId-undefined",
    path: "/project/:projectId()/contact",
    component: component_45stubNJqXUND8TpxJhMGJI6VYCw9xq9hYQu6ZlIQ2YjHb8PY
  },
  {
    name: "project-projectId-undefined",
    path: "/project/:projectId()/faq",
    component: component_45stubNJqXUND8TpxJhMGJI6VYCw9xq9hYQu6ZlIQ2YjHb8PY
  },
  {
    name: "project-projectId-undefined",
    path: "/project/:projectId()/tools",
    component: component_45stubNJqXUND8TpxJhMGJI6VYCw9xq9hYQu6ZlIQ2YjHb8PY
  },
  {
    name: "project-projectId-undefined",
    path: "/project/:projectId()/tools/:pathMatch(.*)",
    component: component_45stubNJqXUND8TpxJhMGJI6VYCw9xq9hYQu6ZlIQ2YjHb8PY
  },
  {
    name: "project-projectId-undefined",
    path: "/project/:projectId()/schedule-a-consultation",
    component: component_45stubNJqXUND8TpxJhMGJI6VYCw9xq9hYQu6ZlIQ2YjHb8PY
  },
  {
    name: component_45stubNJqXUND8TpxJhMGJI6VYCw9xq9hYQu6ZlIQ2YjHb8PYMeta?.name,
    path: "/terms-of-use",
    component: component_45stubNJqXUND8TpxJhMGJI6VYCw9xq9hYQu6ZlIQ2YjHb8PY
  },
  {
    name: "public-design-tokenomics-adjusting-modeling-sell-pressure",
    path: "/design-tokenomics/adjusting/modeling-sell-pressure",
    meta: { ...(modeling_45sell_45pressure2a8uMLBcDqP83illESxlXjUCznjw3lRZD9_9m5R3CcwMeta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/adjusting/modeling-sell-pressure.vue")
  },
  {
    name: "public-design-tokenomics-adjusting-modeling-supply-and-demand",
    path: "/design-tokenomics/adjusting/modeling-supply-and-demand",
    meta: { ...(modeling_45supply_45and_45demandQhj26gAtVxk94p1GNdAnR0asLo0YNw5d8QSKdFt8PhMMeta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/adjusting/modeling-supply-and-demand.vue")
  },
  {
    name: "public-design-tokenomics-adjusting-optimizing-circulating-supply",
    path: "/design-tokenomics/adjusting/optimizing-circulating-supply",
    meta: { ...(optimizing_45circulating_45supply_cVmTxt3UdlW8lIWywOdmTvLxm8kYfLnyIo3wIu4YbIMeta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/adjusting/optimizing-circulating-supply.vue")
  },
  {
    name: "public-design-tokenomics-adjusting-simulating-post-tge-pops",
    path: "/design-tokenomics/adjusting/simulating-post-tge-pops",
    meta: { ...(simulating_45post_45tge_45popsmQssXU1mYvUWkZ_D6d7AB7CQ98GRSTMS_yr__GmQRdIMeta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/adjusting/simulating-post-tge-pops.vue")
  },
  {
    name: "public-design-tokenomics-adjusting-simulating-price-discovery",
    path: "/design-tokenomics/adjusting/simulating-price-discovery",
    meta: { ...(simulating_45price_45discoverypM1Gtw2qHJMzt05sBS6SlOq8s8pyjKTJFQ3_npJC3hcMeta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/adjusting/simulating-price-discovery.vue")
  },
  {
    name: "public-design-tokenomics-modeling-demand-drivers",
    path: "/design-tokenomics/modeling/demand-drivers",
    meta: { ...(demand_45driversUccFkjbtzkmeQvBv6totRjuqXio3n25rH1uDEXmWVkIMeta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/modeling/demand-drivers.vue")
  },
  {
    name: "public-design-tokenomics-modeling-estimating-demand",
    path: "/design-tokenomics/modeling/estimating-demand",
    meta: { ...(estimating_45demand_4N9w9vxVZfL_TOABuzOA7sGvkD6dbN5apjGueNKA0gMeta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/modeling/estimating-demand.vue")
  },
  {
    name: "public-design-tokenomics-modeling-token-distribution-schedule",
    path: "/design-tokenomics/modeling/token-distribution-schedule",
    meta: { ...(token_45distribution_45scheduleLm2JnLInfFYmMXI3nHMPc1yZqqlOdWaPCfH5WzqQvLIMeta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/modeling/token-distribution-schedule.vue")
  },
  {
    name: "public-design-tokenomics-modeling-token-emission-schedule",
    path: "/design-tokenomics/modeling/token-emission-schedule",
    meta: { ...(token_45emission_45scheduleN0RuKN39lWZlYcLhGrjj1H_CyOoVVw_botLU1BAJuY0Meta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/modeling/token-emission-schedule.vue")
  },
  {
    name: "public-design-tokenomics-publish-manage-one-pager",
    path: "/design-tokenomics/publish/manage-one-pager",
    meta: { ...(manage_45one_45pagerXOQnBWOFtb8ugVR_2aa7Qik1ZIALBl2SUyiJqpOCjzYMeta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/publish/manage-one-pager.vue")
  },
  {
    name: "public-design-tokenomics-token-profile-basic-information",
    path: "/design-tokenomics/token-profile/basic-information",
    meta: { ...(basic_45informationzEyWnLVoensd1i2Ojdankpi8FPDreA4wZTwncFCl9T8Meta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/token-profile/basic-information.vue")
  },
  {
    name: "public-design-tokenomics-token-profile-business-model",
    path: "/design-tokenomics/token-profile/business-model",
    meta: { ...(business_45modelgzyaTxRcv8dzZoo7DU6CAkOu9obXfmSDCkku8_Ep3yMMeta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/token-profile/business-model.vue")
  },
  {
    name: "public-design-tokenomics-token-profile-mission-vision",
    path: "/design-tokenomics/token-profile/mission-vision",
    meta: { ...(mission_45visionrDdapW3foi7lWirw_mtC01b2oeNVz1LAQvoT3l5qk_8Meta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/token-profile/mission-vision.vue")
  },
  {
    name: "public-design-tokenomics-token-profile-problem-and-solution",
    path: "/design-tokenomics/token-profile/problem-and-solution",
    meta: { ...(problem_45and_45solutionEzau1SbzwBbwRa8A0DQXRoS8kJunvDHFdBZdKLbDBnwMeta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/token-profile/problem-and-solution.vue")
  },
  {
    name: "public-design-tokenomics-token-profile-product-market-fit",
    path: "/design-tokenomics/token-profile/product-market-fit",
    meta: { ...(product_45market_45fit2rnN4Gfraf3yVTZcBBKyc4Tdff3RDu0XpvGIK_trhE0Meta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/token-profile/product-market-fit.vue")
  },
  {
    name: "public-design-tokenomics-token-profile-value-capture",
    path: "/design-tokenomics/token-profile/value-capture",
    meta: { ...(value_45capturemGKdChV_huVkT87QXHNvKNwQH3xkKHbCshoAjWER2NYMeta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/token-profile/value-capture.vue")
  },
  {
    name: "public-design-tokenomics-token-profile-value-creation",
    path: "/design-tokenomics/token-profile/value-creation",
    meta: { ...(value_45creationxI6d595JCzDdyaH8ga6GsmxDgE4pL2lV8SxJDReEJQkMeta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/token-profile/value-creation.vue")
  },
  {
    name: "public-design-tokenomics-valuation-documenting-fdv-maximum-token-supply",
    path: "/design-tokenomics/valuation-documenting/fdv-maximum-token-supply",
    meta: { ...(fdv_45maximum_45token_45supply7FMEhPuLTSdMXz6lC8bdqffXKp3ajGum8kGF00qdaBoMeta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/valuation-documenting/fdv-maximum-token-supply.vue")
  },
  {
    name: "public-engage-a-market-maker-demo-compare-quotes",
    path: "/engage-a-market-maker/demo/compare-quotes",
    meta: { ...(compare_45quotesecDR48qHy_E3fYuFu_b7pL1tt1cjyb6oDKbUXPcmTJcMeta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/engage-market-maker/pages/engage-a-market-maker/demo/compare-quotes.vue")
  },
  {
    name: "public-engage-a-market-maker-demo",
    path: "/engage-a-market-maker/demo",
    meta: { ...(indexkpZ4gVuvSo6as7VmKlaYE7BeOt52Z4FzUEpbtzk_UOEMeta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/engage-market-maker/pages/engage-a-market-maker/demo/index.vue")
  },
  {
    name: "public-engage-a-market-maker-received-quotes",
    path: "/engage-a-market-maker/received-quotes",
    meta: { ...(received_45quotes6o49vDOsHQNiWe6wDH_0Fw0U2jTjsOTIYIsvJly0EiUMeta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/engage-market-maker/pages/engage-a-market-maker/received-quotes.vue")
  },
  {
    name: "public-engage-a-market-maker-received-requotes",
    path: "/engage-a-market-maker/received-requotes",
    meta: { ...(received_45requotesRy312vjPyXtaaMI4C4Gz3gmCg_2FCcrrR4QdE_b6uv0Meta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/engage-market-maker/pages/engage-a-market-maker/received-requotes.vue")
  },
  {
    name: "public-engage-a-market-maker-request-for-quotations",
    path: "/engage-a-market-maker/request-for-quotations",
    meta: { ...(request_45for_45quotationsB3JXPOkI7m1ZI5qTdkXV_zLNMuCcptrK3SLBcEIxs4sMeta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/engage-market-maker/pages/engage-a-market-maker/request-for-quotations.vue")
  },
  {
    name: "public-list-on-exchanges-exchange-ratings",
    path: "/list-on-exchanges/exchange-ratings",
    meta: { ...(exchange_45ratingsCpMSNNJb16oz8msu8MUSjV0h1hubP3ev9ogi_NIqjrQMeta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/list-on-exchanges/pages/list-on-exchanges/exchange-ratings.vue")
  },
  {
    name: "public-list-on-exchanges-listing-fees",
    path: "/list-on-exchanges/listing-fees",
    meta: { ...(listing_45feesjr2ycoPzusSYYwiXoM1sAk2paKDBQCxAxyyJ26OdhHMMeta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/list-on-exchanges/pages/list-on-exchanges/listing-fees.vue")
  },
  {
    name: "public-market-maker-monitoring-dashboard",
    path: "/market-maker-monitoring/dashboard",
    meta: { ...(dashboard57GYH2hEj2JlV6WLKr4aZIpg_EDRlRNh6mb8YpAjzzsMeta || {}), ...{"middleware":["mmm-v2-pre-activation","check-market-maker-dashboard"],"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/monitor-market-makers/pages/market-maker-monitoring/dashboard.vue")
  },
  {
    name: "public-utr-id-share",
    path: "/utr/:id()/share",
    meta: { ...(sharePbbRTwhU_hPMkP9Lgu_RfGzCRx0Q1GYf1f7oysJIlKYMeta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/public-research/pages/utr/[id]/share.vue")
  },
  {
    name: "public-universal-exchange-rating-exchangeId",
    path: "/universal-exchange-rating/:exchangeId()",
    meta: { ...(_91exchangeId_93Yov3z_S9R8_7hiMpD4iX9zjTAdRAnV4d7V01VZLrUd8Meta || {}), ...{"middleware":["uer-enabled"],"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/public-research/pages/universal-exchange-rating/[exchangeId].vue")
  },
  {
    name: "public-analyze-trade-activity",
    path: "/analyze-trade-activity",
    meta: { ...(indexZJ9a_YoiSPwF320_yVlht1ZNPhC_GZACBcpmE2bfPMgMeta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/trade-activity/pages/analyze-trade-activity/index.vue")
  },
  {
    name: "public-ask",
    path: "/ask",
    meta: { ...(askgM7ZPouZst8_BOM8IP9_aKR2829KMrpl1z09_hlWM_UMeta || {}), ...{"middleware":["ai-chat-enabled"],"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/ai-chat/pages/ask.vue")
  },
  {
    name: "public-design-tokenomics",
    path: "/design-tokenomics",
    meta: { ...(indextr3zpUO0UUWMgSgsJCuaS3lYVql8KzDzX1Pn_LLw2BMMeta || {}), ...{"middleware":"design-tokenomics-scope","allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/design-tokenomics/pages/design-tokenomics/index.vue")
  },
  {
    name: "public-engage-a-market-maker",
    path: "/engage-a-market-maker",
    meta: { ...(indexVj8OawVyaXbSZkQkfce29Dv60Kl5Mc2foCjl8a33D4IMeta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/engage-market-maker/pages/engage-a-market-maker/index.vue")
  },
  {
    name: "public-list-on-exchanges",
    path: "/list-on-exchanges",
    meta: { ...(indexA_OMR81fehF1eqSCX9UWLgSmUs1mRA2GESPEwTrBXG8Meta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/list-on-exchanges/pages/list-on-exchanges/index.vue")
  },
  {
    name: "public-market-maker-monitoring",
    path: "/market-maker-monitoring",
    meta: { ...(indexPNFY0G6yj6JIqlCH2itWITnt1oJl3WX3PpvkpOMuoEcMeta || {}), ...{"middleware":["mmm-v2-pre-activation","check-market-maker-dashboard"],"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/free-tools/monitor-market-makers/pages/market-maker-monitoring/index.vue")
  },
  {
    name: "public-token-unlocks",
    path: "/token-unlocks",
    meta: {"allowPreLogin":true},
    component: () => import("/app/apps/ui/layers/free-tools/token-unlocks/pages/token-unlocks/index.vue")
  },
  {
    name: "public-universal-exchange-rating",
    path: "/universal-exchange-rating",
    meta: { ...(indexefloXmcYGy_fevfCUkYH2VQAMO6fCMJOpVqTp15PXxkMeta || {}), ...{"middleware":["uer-enabled"],"allowPreLogin":true} },
    component: () => import("/app/apps/ui/layers/public-research/pages/universal-exchange-rating/index.vue")
  },
  {
    name: "project-projectId-index",
    path: "/project/:projectId()",
    meta: { ...(indexxkl7THrorjELX0PmwfNI1rncgoIz67vMSTWZxNvAZMQMeta || {}), ...{"allowPreLogin":true} },
    component: () => import("/app/apps/ui/pages/index.vue")
  }
]